// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-e835b6e6]{display:none}.information-box[data-v-e835b6e6]{border-radius:var(--border-radius-common);margin:8px 1rem;padding:8px 16px}@media(min-width:1024px){.information-box[data-v-e835b6e6]{margin:1rem 0}}.information-box[data-v-e835b6e6]>:not([hidden])~:not([hidden]){margin-bottom:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
